/* eslint-disable import/first */
import React from 'react';
import { useNavigate, useLocation } from '@reach/router';
import enabledCartBag from '../../containers/Deal/images/cartBag.svg';
import css from './index.module.scss';
import noImg from '../../assets/no-itm.png';
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
import { FormattedMessage, useIntl } from 'react-intl';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;

import { checkoutInitiatedGA, placeOrderGA, viewCartGA } from 'spwa-ui-library/esm/utils/helperGA';
import classNames from 'classnames';
const { selectCountryValidations } = Slices.configSlice;

const { selectDesktop } = Slices.appSlice;
const { selectLoginStatus } = Slices.authSlice;
const { selectDefaultAddress } = Slices.addressSlice;
const { couponCodeApplied } = Slices.offerSlice;
const { selectProductEntities } = Slices.productSlice;
const { selectCurrentCountry, getCurrentProfile } = Slices.profileSlice;

export default function ViewCartButton({
  validate,
  onClick,
  buttonText,
  to,
  amount,
  currency,
  cart,
  reviewCart,
  setAmtAlert,
  setReviewPopUp,
  hideInfo = false,
  hideImg,
}) {
  const navigate = useNavigate();
  const intl = useIntl();
  const location = useLocation();
  const isDesktop = useSelector(selectDesktop);
  const address = useSelector(selectDefaultAddress);
  const user = useSelector(selectLoginStatus);
  const productsMap = useSelector(selectProductEntities);
  const currentProfile = useSelector(getCurrentProfile);
  const categoryList = useSelector((state) => state.category);
  const offerSelected = useSelector(couponCodeApplied);

  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const handleNavigation = (e) => {
    if (!validate) {
      setAmtAlert && setAmtAlert(false);
      if (
        buttonText &&
        (buttonText.props.defaultMessage === 'Place Order' ||
          buttonText.props.defaultMessage === 'Checkout')
      ) {
        placeOrderGA(cart, user, categoryList);
        checkoutInitiatedGA(cart, currency, categoryList, offerSelected);
      } else {
        viewCartGA(cart, currency, categoryList);
      }
      if (typeof onClick === 'function') {
        onClick();
      } else {
        if (reviewCart) {
          setReviewPopUp(true);
        } else {
          if (to) {
            if (to === '/guest') {
              navigate(`/${intl.locale}${to}`, {
                state: { oldLocation: location, retUrl: '/guest' },
              });
            } else if (to === '/addAddress') {
              if (isDesktop) {
                navigate(`${location.pathname}?modal=addaddress`, {
                  state: { retUrl: '/guest' },
                });
              } else {
                navigate(`/${intl.locale}${to}`, {
                  state: { retUrl: '/guest', action: 'select' },
                });
              }
            } else if (to === '/checkout') {
              if (!Object.entries(address).length) {
                if (isDesktop) {
                  navigate(`${location.pathname}?modal=delivery`);
                } else {
                  navigate(`/${intl.locale}/delivery`, {
                    state: { action: 'select' },
                  });
                }
              } else {
                if (currentProfile.profileStep) {
                  navigate(`/${intl.locale}${to}`);
                } else {
                  navigate(`/${intl.locale}/create-profile`, {
                    state: {
                      oldLocation: JSON.parse(JSON.stringify(location)),
                      retUrl: '/checkout',
                    },
                  });
                }
              }
            } else {
              navigate(`/${intl.locale}${to}`);
            }
          } else {
            navigate(`/${intl.locale}/cart`);
          }
        }
      }
    } else {
      setAmtAlert && setAmtAlert(true);
    }
  };
  const indexSubTotal = cart?.amount?.findIndex((item) => item.type === 'SUB_TOTAL');
  const subTotal = cart?.amount?.[indexSubTotal]?.amount || 0;
  const countOfItems = cart?.data?.items?.reduce((a, { qty }) => a + qty, 0);
  const lastCartItemId = cart?.data?.items?.[cart?.data?.items?.length - 1 || 0]?.id;
  const cartImg = productsMap[lastCartItemId]?.assets[0]?.src;
  //TODO: changes on structure - add span as discussed
  return (
    <div className={css.checkoutSection} onClick={handleNavigation}>
      <div className={css.cartAmount}>
        {!hideInfo && (
          <img
            src={cartImg}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = noImg;
            }}
          />
        )}
        <div className={classNames(css.amountInfo, { [css.checkoutDesk]: isDesktop })}>
          {!hideInfo && (
            <span className={css.itemCount}>
              {countOfItems || 0} <FormattedMessage id={'item'} defaultMessage={'ITEM'} />{' '}
            </span>
          )}
          <span className={css.cartPrice}>
            <span>
              {buttonText ? decimalChecker(amount) : decimalChecker(subTotal)} {currency}
            </span>
            <span className={css.inclusive}>
              <FormattedMessage id={'inclusive_of_taxes'} defaultMessage={'Inclusive of Taxes'} />
            </span>
          </span>
        </div>
      </div>
      <div className={css.checkoutButton}>
        <span className={css.label}>
          {!hideInfo && !hideImg && (
            <img
              src={enabledCartBag}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = noImg;
              }}
            />
          )}
          {buttonText || <FormattedMessage id="cart_view" defaultMessage="View Cart" />}
        </span>
      </div>
    </div>
  );
}
